export async function getLocalStorage<T extends string>(key: string): Promise<T | undefined> {
  const data: { [key: string]: string } = await chrome.storage.local.get([key]);
  return data[key] as T;
}

export async function setLocalStorage(key: string, value: unknown): Promise<void> {
  await chrome.storage.local.set({ [key]: value });
}
